/* tslint:disable */
/* eslint-disable */
/**
 * 【モニタリング】コミュニケーション機能 業務AP (隊員)
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 有効フラグ:enum
 * @export
 * @enum {string}
 */

export const DomEnableFlag = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;

export type DomEnableFlag = typeof DomEnableFlag[keyof typeof DomEnableFlag];


/**
 * 会議室状態:enum
 * @export
 * @enum {string}
 */

export const DomRoomState = {
    Empty: 'empty',
    Idle: 'idle',
    Waiting: 'waiting',
    Preparing: 'preparing',
    Active: 'active',
    Finishing: 'finishing'
} as const;

export type DomRoomState = typeof DomRoomState[keyof typeof DomRoomState];


/**
 * ChimeSDK meeting Attendee
 * @export
 * @interface EntityAttendee
 */
export interface EntityAttendee {
    /**
     * 
     * @type {string}
     * @memberof EntityAttendee
     */
    'ExternalUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityAttendee
     */
    'AttendeeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityAttendee
     */
    'JoinToken'?: string | null;
    /**
     * 
     * @type {EntityAttendeeCapabilities}
     * @memberof EntityAttendee
     */
    'Capabilities'?: EntityAttendeeCapabilities | null;
}
/**
 * 
 * @export
 * @interface EntityAttendeeCapabilities
 */
export interface EntityAttendeeCapabilities {
    /**
     * 
     * @type {string}
     * @memberof EntityAttendeeCapabilities
     */
    'Audio'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityAttendeeCapabilities
     */
    'Video'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityAttendeeCapabilities
     */
    'Content'?: string | null;
}
/**
 * エラーレスポンス
 * @export
 * @interface EntityErrorMsg
 */
export interface EntityErrorMsg {
    /**
     * エラー番号
     * @type {string}
     * @memberof EntityErrorMsg
     */
    'errorNo'?: string;
    /**
     * エラーメッセージ
     * @type {string}
     * @memberof EntityErrorMsg
     */
    'errorMsg'?: string;
}
/**
 * 
 * @export
 * @interface EntityLocation
 */
export interface EntityLocation {
    /**
     * 契約先ID:number
     * @type {number}
     * @memberof EntityLocation
     */
    'locationId'?: number;
    /**
     * GC番号:string
     * @type {string}
     * @memberof EntityLocation
     */
    'gcNo'?: string;
    /**
     * 号機番号:string
     * @type {string}
     * @memberof EntityLocation
     */
    'gouki'?: string;
    /**
     * 電計番号:string
     * @type {string}
     * @memberof EntityLocation
     */
    'denkei'?: string;
    /**
     * 対象先名称
     * @type {string}
     * @memberof EntityLocation
     */
    'name'?: string;
    /**
     * 
     * @type {DomEnableFlag}
     * @memberof EntityLocation
     */
    'isEnabled'?: DomEnableFlag;
}


/**
 * Amazon Chime SDK Meeting
 * @export
 * @interface EntityMeeting
 */
export interface EntityMeeting {
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'MeetingId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'MeetingHostId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'ExternalMeetingId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'MediaRegion'?: string | null;
    /**
     * 
     * @type {EntityMeetingMediaPlacement}
     * @memberof EntityMeeting
     */
    'MediaPlacement'?: EntityMeetingMediaPlacement | null;
    /**
     * 
     * @type {EntityMeetingMeetingFeatures}
     * @memberof EntityMeeting
     */
    'MeetingFeatures'?: EntityMeetingMeetingFeatures | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'PrimaryMeetingId'?: string | null;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof EntityMeeting
     */
    'TenantIds'?: Array<string | null> | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeeting
     */
    'MeetingArn'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingDetail
 */
export interface EntityMeetingDetail {
    /**
     * 
     * @type {EntityMeetingRoom}
     * @memberof EntityMeetingDetail
     */
    'room'?: EntityMeetingRoom;
    /**
     * 
     * @type {EntityRoomStatus}
     * @memberof EntityMeetingDetail
     */
    'status'?: EntityRoomStatus;
    /**
     * 
     * @type {EntityLocation}
     * @memberof EntityMeetingDetail
     */
    'location'?: EntityLocation;
    /**
     * 
     * @type {Array<EntitySecondaryOrganizationMember>}
     * @memberof EntityMeetingDetail
     */
    'secondaryOrganizationMembers'?: Array<EntitySecondaryOrganizationMember> | null;
    /**
     * 
     * @type {EntityMeeting}
     * @memberof EntityMeetingDetail
     */
    'meeting'?: EntityMeeting;
    /**
     * 
     * @type {EntityAttendee}
     * @memberof EntityMeetingDetail
     */
    'attendee'?: EntityAttendee;
}
/**
 * 
 * @export
 * @interface EntityMeetingMediaPlacement
 */
export interface EntityMeetingMediaPlacement {
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'AudioHostUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'AudioFallbackUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'SignalingUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'TurnControlUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'ScreenDataUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'ScreenViewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMediaPlacement
     */
    'EventIngestionUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingMeetingFeatures
 */
export interface EntityMeetingMeetingFeatures {
    /**
     * 
     * @type {EntityMeetingMeetingFeaturesAudio}
     * @memberof EntityMeetingMeetingFeatures
     */
    'Audio'?: EntityMeetingMeetingFeaturesAudio | null;
    /**
     * 
     * @type {EntityMeetingMeetingFeaturesVideo}
     * @memberof EntityMeetingMeetingFeatures
     */
    'Video'?: EntityMeetingMeetingFeaturesVideo | null;
    /**
     * 
     * @type {EntityMeetingMeetingFeaturesVideo}
     * @memberof EntityMeetingMeetingFeatures
     */
    'Content'?: EntityMeetingMeetingFeaturesVideo | null;
    /**
     * 
     * @type {EntityMeetingMeetingFeaturesAttendee}
     * @memberof EntityMeetingMeetingFeatures
     */
    'Attendee'?: EntityMeetingMeetingFeaturesAttendee | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingMeetingFeaturesAttendee
 */
export interface EntityMeetingMeetingFeaturesAttendee {
    /**
     * 
     * @type {number}
     * @memberof EntityMeetingMeetingFeaturesAttendee
     */
    'MaxCount'?: number | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingMeetingFeaturesAudio
 */
export interface EntityMeetingMeetingFeaturesAudio {
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMeetingFeaturesAudio
     */
    'EchoReduction'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingMeetingFeaturesVideo
 */
export interface EntityMeetingMeetingFeaturesVideo {
    /**
     * 
     * @type {string}
     * @memberof EntityMeetingMeetingFeaturesVideo
     */
    'MaxResolution'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityMeetingRoom
 */
export interface EntityMeetingRoom {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityMeetingRoom
     */
    'serviceId'?: number;
    /**
     * 会議室ID:number
     * @type {number}
     * @memberof EntityMeetingRoom
     */
    'roomId'?: number;
    /**
     * 会議室名称
     * @type {string}
     * @memberof EntityMeetingRoom
     */
    'name'?: string;
    /**
     * 表示順:number
     * @type {number}
     * @memberof EntityMeetingRoom
     */
    'viewOrder'?: number;
    /**
     * 
     * @type {DomEnableFlag}
     * @memberof EntityMeetingRoom
     */
    'isEnabled'?: DomEnableFlag;
    /**
     * 
     * @type {DomRoomState}
     * @memberof EntityMeetingRoom
     */
    'state'?: DomRoomState;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityMeetingRoom
     */
    'ownerId'?: number;
    /**
     * 主催者の名前
     * @type {string}
     * @memberof EntityMeetingRoom
     */
    'ownerName'?: string | null;
    /**
     * 
     * @type {EntityLocation}
     * @memberof EntityMeetingRoom
     */
    'location'?: EntityLocation;
}


/**
 * 
 * @export
 * @interface EntityRoomStatus
 */
export interface EntityRoomStatus {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityRoomStatus
     */
    'serviceId'?: number;
    /**
     * 会議室ID:number
     * @type {number}
     * @memberof EntityRoomStatus
     */
    'roomId'?: number;
    /**
     * 
     * @type {DomRoomState}
     * @memberof EntityRoomStatus
     */
    'state'?: DomRoomState;
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityRoomStatus
     */
    'organizationId'?: number;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityRoomStatus
     */
    'owner'?: number;
    /**
     * 待機開始日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'idlingStartAt'?: string | null;
    /**
     * 待ち受け開始日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'waitingStartAt'?: string | null;
    /**
     * 隊員入室日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'crewCheckinAt'?: string | null;
    /**
     * 会議開始日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'meetingStartAt'?: string | null;
    /**
     * 会議終了日時
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'meetingFinishAt'?: string | null;
    /**
     * 会議ID:uuid
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'meetingUuid'?: string;
    /**
     * ChimeID:uuid
     * @type {string}
     * @memberof EntityRoomStatus
     */
    'chimeUuid'?: string;
}


/**
 * 
 * @export
 * @interface EntitySecondaryOrganizationMember
 */
export interface EntitySecondaryOrganizationMember {
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntitySecondaryOrganizationMember
     */
    'memberId'?: number;
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntitySecondaryOrganizationMember
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'name'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'email'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'tel1'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'tel2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'tel3'?: string;
    /**
     * 電話番号/SMS（E.164）
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'sms'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntitySecondaryOrganizationMember
     */
    'email2'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntitySecondaryOrganizationMember
     */
    'comment'?: any;
}
/**
 * 
 * @export
 * @interface EntityService
 */
export interface EntityService {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityService
     */
    'serviceId'?: number;
    /**
     * サービス名称
     * @type {string}
     * @memberof EntityService
     */
    'name'?: string;
    /**
     * 表示順:number
     * @type {number}
     * @memberof EntityService
     */
    'viewOrder'?: number;
    /**
     * 
     * @type {DomEnableFlag}
     * @memberof EntityService
     */
    'isEnabled'?: DomEnableFlag;
}


/**
 * 
 * @export
 * @interface GetPhoto200Response
 */
export interface GetPhoto200Response {
    /**
     * S3 Signed URI
     * @type {string}
     * @memberof GetPhoto200Response
     */
    'image'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof GetPhoto200Response
     */
    'expired'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof GetPhoto200Response
     */
    'takenAt'?: string;
}
/**
 * 
 * @export
 * @interface GetPhotos200ResponseInner
 */
export interface GetPhotos200ResponseInner {
    /**
     * 写真ID:uuid
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'photoId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'mime'?: string;
    /**
     * S3 Signed URI
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'thumbnail'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'expired'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof GetPhotos200ResponseInner
     */
    'takenAt'?: string;
}
/**
 * 
 * @export
 * @interface RequestPhotoUrlRequest
 */
export interface RequestPhotoUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestPhotoUrlRequest
     */
    'mime'?: string | null;
}
/**
 * 
 * @export
 * @interface RequestTakePhoto200Response
 */
export interface RequestTakePhoto200Response {
    /**
     * 
     * @type {string}
     * @memberof RequestTakePhoto200Response
     */
    'msg'?: string | null;
}

/**
 * CrewApi - axios parameter creator
 * @export
 */
export const CrewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 会議入室(隊員)
         * @param {number} serviceId サービスID
         * @param {number} roomId 会議室ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterRoom: async (serviceId: number, roomId: number, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('enterRoom', 'serviceId', serviceId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('enterRoom', 'roomId', roomId)
            const localVarPath = `/crew/{serviceId}/{roomId}/enter`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の会議室の詳細情報を取得する
         * @summary 会議室詳細/開催中会議情報取得
         * @param {number} roomId 会議室ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomDetail: async (roomId: number, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getRoomDetail', 'roomId', roomId)
            const localVarPath = `/crew/meeting-room/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 該当のサービスに割り当てられた会議室の一覧を取得する
         * @summary 会議室一覧取得
         * @param {number} serviceId サービスID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRooms: async (serviceId: number, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getRooms', 'serviceId', serviceId)
            const localVarPath = `/crew/service/{serviceId}/meeting-rooms`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 会議・RTCの参加（隊員）
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinMeeting: async (meetingId: string, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('joinMeeting', 'meetingId', meetingId)
            const localVarPath = `/crew/meeting/{meetingId}/join`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 会議・RTCの退室
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveMeeting: async (meetingId: string, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('leaveMeeting', 'meetingId', meetingId)
            const localVarPath = `/crew/meeting/{meetingId}/leave`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CrewApi - functional programming interface
 * @export
 */
export const CrewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CrewApiAxiosParamCreator(configuration)
    return {
        /**
         * 会議入室(隊員)
         * @param {number} serviceId サービスID
         * @param {number} roomId 会議室ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterRoom(serviceId: number, roomId: number, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterRoom(serviceId, roomId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrewApi.enterRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の会議室の詳細情報を取得する
         * @summary 会議室詳細/開催中会議情報取得
         * @param {number} roomId 会議室ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomDetail(roomId: number, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomDetail(roomId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrewApi.getRoomDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 該当のサービスに割り当てられた会議室の一覧を取得する
         * @summary 会議室一覧取得
         * @param {number} serviceId サービスID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRooms(serviceId: number, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRooms(serviceId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrewApi.getRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 会議・RTCの参加（隊員）
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinMeeting(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinMeeting(meetingId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrewApi.joinMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 会議・RTCの退室
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveMeeting(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMeetingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveMeeting(meetingId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrewApi.leaveMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CrewApi - factory interface
 * @export
 */
export const CrewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CrewApiFp(configuration)
    return {
        /**
         * 会議入室(隊員)
         * @param {number} serviceId サービスID
         * @param {number} roomId 会議室ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterRoom(serviceId: number, roomId: number, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.enterRoom(serviceId, roomId, xCREWID, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の会議室の詳細情報を取得する
         * @summary 会議室詳細/開催中会議情報取得
         * @param {number} roomId 会議室ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomDetail(roomId: number, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.getRoomDetail(roomId, xCREWID, options).then((request) => request(axios, basePath));
        },
        /**
         * 該当のサービスに割り当てられた会議室の一覧を取得する
         * @summary 会議室一覧取得
         * @param {number} serviceId サービスID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRooms(serviceId: number, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.getRooms(serviceId, xCREWID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 会議・RTCの参加（隊員）
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinMeeting(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.joinMeeting(meetingId, xCREWID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 会議・RTCの退室
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveMeeting(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityMeetingDetail> {
            return localVarFp.leaveMeeting(meetingId, xCREWID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CrewApi - object-oriented interface
 * @export
 * @class CrewApi
 * @extends {BaseAPI}
 */
export class CrewApi extends BaseAPI {
    /**
     * 会議入室(隊員)
     * @param {number} serviceId サービスID
     * @param {number} roomId 会議室ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrewApi
     */
    public enterRoom(serviceId: number, roomId: number, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return CrewApiFp(this.configuration).enterRoom(serviceId, roomId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の会議室の詳細情報を取得する
     * @summary 会議室詳細/開催中会議情報取得
     * @param {number} roomId 会議室ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrewApi
     */
    public getRoomDetail(roomId: number, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return CrewApiFp(this.configuration).getRoomDetail(roomId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 該当のサービスに割り当てられた会議室の一覧を取得する
     * @summary 会議室一覧取得
     * @param {number} serviceId サービスID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrewApi
     */
    public getRooms(serviceId: number, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return CrewApiFp(this.configuration).getRooms(serviceId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 会議・RTCの参加（隊員）
     * @param {string} meetingId 会議ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrewApi
     */
    public joinMeeting(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return CrewApiFp(this.configuration).joinMeeting(meetingId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 会議・RTCの退室
     * @param {string} meetingId 会議ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrewApi
     */
    public leaveMeeting(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return CrewApiFp(this.configuration).leaveMeeting(meetingId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeetingPhotoApi - axios parameter creator
 * @export
 */
export const MeetingPhotoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 画像登録失敗
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failTakePhoto: async (meetingId: string, photoId: string, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('failTakePhoto', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('failTakePhoto', 'photoId', photoId)
            const localVarPath = `/crew/meeting/{meetingId}/photo/{photoId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像取得
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto: async (meetingId: string, photoId: string, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getPhoto', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('getPhoto', 'photoId', photoId)
            const localVarPath = `/crew/meeting/{meetingId}/photo/{photoId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像一覧取得
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotos: async (meetingId: string, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getPhotos', 'meetingId', meetingId)
            const localVarPath = `/crew/meeting/{meetingId}/photos`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像登録用URL発行
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {RequestPhotoUrlRequest} [requestPhotoUrlRequest] ファイルタイプ（MIME）。指定なしの時は”image/jpeg\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPhotoUrl: async (meetingId: string, photoId: string, xCREWID?: string, requestPhotoUrlRequest?: RequestPhotoUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('requestPhotoUrl', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('requestPhotoUrl', 'photoId', photoId)
            const localVarPath = `/crew/meeting/{meetingId}/photo/{photoId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPhotoUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像共有終了要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestShareFinish: async (meetingId: string, photoId: string, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('requestShareFinish', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('requestShareFinish', 'photoId', photoId)
            const localVarPath = `/crew/meeting/{meetingId}/photo/{photoId}/share`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 画像共有要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestShareStart: async (meetingId: string, photoId: string, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('requestShareStart', 'meetingId', meetingId)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('requestShareStart', 'photoId', photoId)
            const localVarPath = `/crew/meeting/{meetingId}/photo/{photoId}/share`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 写真撮影要求
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTakePhoto: async (meetingId: string, xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('requestTakePhoto', 'meetingId', meetingId)
            const localVarPath = `/crew/meeting/{meetingId}/photo`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingPhotoApi - functional programming interface
 * @export
 */
export const MeetingPhotoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingPhotoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 画像登録失敗
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async failTakePhoto(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestTakePhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.failTakePhoto(meetingId, photoId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.failTakePhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像取得
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhoto(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhoto(meetingId, photoId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.getPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像一覧取得
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhotos(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPhotos200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhotos(meetingId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.getPhotos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像登録用URL発行
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {RequestPhotoUrlRequest} [requestPhotoUrlRequest] ファイルタイプ（MIME）。指定なしの時は”image/jpeg\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPhotoUrl(meetingId: string, photoId: string, xCREWID?: string, requestPhotoUrlRequest?: RequestPhotoUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPhotoUrl(meetingId, photoId, xCREWID, requestPhotoUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.requestPhotoUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像共有終了要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestShareFinish(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestTakePhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestShareFinish(meetingId, photoId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.requestShareFinish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 画像共有要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestShareStart(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestTakePhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestShareStart(meetingId, photoId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.requestShareStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 写真撮影要求
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestTakePhoto(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestTakePhoto200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestTakePhoto(meetingId, xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPhotoApi.requestTakePhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingPhotoApi - factory interface
 * @export
 */
export const MeetingPhotoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingPhotoApiFp(configuration)
    return {
        /**
         * 
         * @summary 画像登録失敗
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failTakePhoto(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<RequestTakePhoto200Response> {
            return localVarFp.failTakePhoto(meetingId, photoId, xCREWID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像取得
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPhoto200Response> {
            return localVarFp.getPhoto(meetingId, photoId, xCREWID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像一覧取得
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotos(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetPhotos200ResponseInner>> {
            return localVarFp.getPhotos(meetingId, xCREWID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像登録用URL発行
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {RequestPhotoUrlRequest} [requestPhotoUrlRequest] ファイルタイプ（MIME）。指定なしの時は”image/jpeg\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPhotoUrl(meetingId: string, photoId: string, xCREWID?: string, requestPhotoUrlRequest?: RequestPhotoUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPhoto200Response> {
            return localVarFp.requestPhotoUrl(meetingId, photoId, xCREWID, requestPhotoUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像共有終了要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestShareFinish(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<RequestTakePhoto200Response> {
            return localVarFp.requestShareFinish(meetingId, photoId, xCREWID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 画像共有要求
         * @param {string} meetingId 会議ID
         * @param {string} photoId 写真ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestShareStart(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<RequestTakePhoto200Response> {
            return localVarFp.requestShareStart(meetingId, photoId, xCREWID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 写真撮影要求
         * @param {string} meetingId 会議ID
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTakePhoto(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<RequestTakePhoto200Response> {
            return localVarFp.requestTakePhoto(meetingId, xCREWID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingPhotoApi - object-oriented interface
 * @export
 * @class MeetingPhotoApi
 * @extends {BaseAPI}
 */
export class MeetingPhotoApi extends BaseAPI {
    /**
     * 
     * @summary 画像登録失敗
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public failTakePhoto(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).failTakePhoto(meetingId, photoId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像取得
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public getPhoto(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).getPhoto(meetingId, photoId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像一覧取得
     * @param {string} meetingId 会議ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public getPhotos(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).getPhotos(meetingId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像登録用URL発行
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {string} [xCREWID] 隊員番号
     * @param {RequestPhotoUrlRequest} [requestPhotoUrlRequest] ファイルタイプ（MIME）。指定なしの時は”image/jpeg\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public requestPhotoUrl(meetingId: string, photoId: string, xCREWID?: string, requestPhotoUrlRequest?: RequestPhotoUrlRequest, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).requestPhotoUrl(meetingId, photoId, xCREWID, requestPhotoUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像共有終了要求
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public requestShareFinish(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).requestShareFinish(meetingId, photoId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 画像共有要求
     * @param {string} meetingId 会議ID
     * @param {string} photoId 写真ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public requestShareStart(meetingId: string, photoId: string, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).requestShareStart(meetingId, photoId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 写真撮影要求
     * @param {string} meetingId 会議ID
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPhotoApi
     */
    public requestTakePhoto(meetingId: string, xCREWID?: string, options?: RawAxiosRequestConfig) {
        return MeetingPhotoApiFp(this.configuration).requestTakePhoto(meetingId, xCREWID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceApi - axios parameter creator
 * @export
 */
export const ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 現在有効なサービスの一覧を取得する
         * @summary サービス一覧取得
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService: async (xCREWID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCREWID != null) {
                localVarHeaderParameter['X-CREW-ID'] = String(xCREWID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceApi - functional programming interface
 * @export
 */
export const ServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 現在有効なサービスの一覧を取得する
         * @summary サービス一覧取得
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getService(xCREWID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getService(xCREWID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceApi.getService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceApi - factory interface
 * @export
 */
export const ServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceApiFp(configuration)
    return {
        /**
         * 現在有効なサービスの一覧を取得する
         * @summary サービス一覧取得
         * @param {string} [xCREWID] 隊員番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getService(xCREWID?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityService>> {
            return localVarFp.getService(xCREWID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
export class ServiceApi extends BaseAPI {
    /**
     * 現在有効なサービスの一覧を取得する
     * @summary サービス一覧取得
     * @param {string} [xCREWID] 隊員番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getService(xCREWID?: string, options?: RawAxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getService(xCREWID, options).then((request) => request(this.axios, this.basePath));
    }
}



